import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/jobs/")({
  beforeLoad: () => {
    throw redirect({
      to: "/calendar",
      replace: true,
    })
  },
})
